/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import Game from '../../Game/Game';
import { Easing, Tween } from '../../Utility/Tween';
import Reel from '../Reel';
import { SpinStates } from './SpinStates';
import ReelActionBase from './ReelActionBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Handles the cockback effect when the [[Reel]] starts spinning. */
@cc._decorator.ccclass
@cc._decorator.executionOrder(-1)
export default class Cockback extends ReelActionBase
{
    protected duration: number = 0.08;

    /** How far should the reel cock back. */
    @property({ visible: true, type: cc.Integer })
    private _distance: number = 40;

    /** @hidden */
    private _curLocation: number = 0;
    /** @hidden */
    private _travelDistance: number = 0;

    /** Has the cockback effect completed. */
    public get IsComplete(): boolean { return this.elapsedTime > this.duration; }

    /** @hidden */
    private complete(): void
    {
        this.reel.SetSpinState(SpinStates.RampingUp);
    }

    /** @hidden */
    protected update(dt: number): void
    {
        super.update(dt);

        dt = this.dtModObservable.Multiply(dt);

        let timeProgress: number = this.elapsedTime / this.duration;
        let oldLocation: number = this._curLocation;
        this._curLocation = Tween.TweenNumber(0, this._distance, timeProgress, Easing.InvQuadratic);
        this._travelDistance = this._curLocation - oldLocation;
        this.elapsedTime += dt;
        this.reel.Position -= this._travelDistance;

        if (this.IsComplete)
        {
            this.complete();
        }
    }

    /** @hidden */
    protected reset(): void
    {
        this.elapsedTime = 0;
        this._curLocation = 0;

        if (this.reel == null)
        {
            this.reel = this.getComponent(Reel);
        }

        if (this.reel.SpinningUp)
        {
            if (this._distance > 0) { this._distance *= -1; }
        }
        else
        {
            if (this._distance < 0) { this._distance *= -1; }
        }

        if (this._distance === 0)
        {
            this.complete();
        }
    }
}
